import React, { useContext, useEffect } from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { DataLayerEventContext } from '../../../contexts/dataLayerEventContext';

const SuccessRegistered = ({ setScreenNumber, handleNextButtonClick }) => {
  const { sendEvent } = useContext(DataLayerEventContext);

  useEffect(() => {
    sendEvent('passed_registration');
  }, []);

  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-hostess/bg.png')}")`
      }}
    >
      <p className={styles.title}>Дякуємо, що приділив час на опитування!</p>
      <p className={styles.coloredDescription}>
        Твій рахунок буде поповнено найближчим часом.
      </p>
      <p className={styles.description}>
        Долучайся у Телеграм "Mr. Philip", щоб бути на зв'язку зі своїм брендом.
      </p>
      <img
        src={getImageFromS3('images/ua-brand/result-sms-notifications.png')}
        alt="result-image"
      />
      <button onClick={handleNextButtonClick}>Далі</button>
    </div>
  );
};

export default SuccessRegistered;
